import { useLocation } from 'react-router';

import { Box } from '@mui/material';

// project import
import TTSOnboardingNavStatus from 'features/tts-onboarding/components/TTSOnboardingNavStatus';

import { APP_DEFAULT_PATH } from 'constants/appConstants';

import NavUser from './NavUser';
import Navigation from './Navigation';

import { SimpleBarScroll as SimpleBar } from '@trendiolive/trendio-selfcare-ui-kit';

// ==============================|| DRAWER CONTENT ||============================== //

export default function DrawerContent() {
  const { pathname } = useLocation();
  const isHomePage = pathname === APP_DEFAULT_PATH || pathname === `${APP_DEFAULT_PATH}/`;

  return (
    <Box sx={{ display: 'flex', flex: 1, flexDirection: 'column', minHeight: 0 }}>
      <SimpleBar
        sx={{
          flex: 1,
          minHeight: 0,
          '& .simplebar-content': { display: 'flex', flexDirection: 'column' }
        }}
      >
        <Navigation />
      </SimpleBar>
      {!isHomePage && <TTSOnboardingNavStatus />}
      <NavUser />
    </Box>
  );
}
